var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 72,
    viewBox: "0 0 130 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.69141 47.4681L17.2392 11.4058L17.6498 9.6001L60.2483 19.5572L91.966 25.0775L106.08 44.6143L101.666 43.6504L120.091 47.6745V69.3944L92.3254 71.2001L66.561 70.3231L38.5898 71.2001L31.0452 70.3231L29.0436 69.6524H21.4477H18.7789L7.89832 68.5174V61.3462L7.23111 60.4691V59.7984L7.89832 59.3341V54.8457H6.7692V47.4681H5.69141Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.252 11.4675L34.0416 41.2427L66.1567 44.922V43.9398L34.5065 39.7953L17.7686 10.2786L17.252 11.4675Z",
    stroke: "#8FA1AC",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5589 39.7952L34.1973 41.2426",
    stroke: "#8FA1AC",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.091 44.241L92.6259 24.3392L17.6667 9.50317L5.57812 46.7222H7.02462L18.1833 13.07",
    stroke: "#8FA1AC",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M37.5546 48.5312L66.1569 50.8532L66.4148 68.9053L37.5546 69.6737L29.4956 68.7949H27.6875V49.6168H29.4956L37.5546 48.5312Z",
    fill: "#B1D6DE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M120.882 46.9805L92.3658 41.1909L66.4141 43.8904V45.6997V68.9616",
    stroke: "#8FA1AC",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02344 46.7222V54.1143H10.227V58.9217H7.02344V59.5937L7.54004 60.2141V63.755V67.7614",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.54102 67.296L16.065 67.9163L18.1314 67.6578L27.6886 68.6917L29.1867 68.4849L37.9173 69.1569L67.6221 68.5366L92.3674 69.984L120.677 67.6061V46.5154",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.90234 54.321V58.9217",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2713 67.9162L16.168 31.3175L24.8469 28.1125V47.1356L17.6661 47.6525L17.8728 67.6578",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3008 29.7668V47.4459",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.541 29.3533V47.4458",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8828 47.0839V30.8006L24.8459 30.2837",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3007 31.6277L18.6992 32.2997L18.9059 47.4458",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M27.584 68.3297V49.4617L29.1855 49.6168L37.0895 48.5312L66.1562 50.8532V68.6474",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2441 41.9146V48.5313",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8535 49.6169V68.7434",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M70.5401 50.3374H66.9297V66.1201L70.5401 66.3264V50.3374Z",
    fill: "#B1D6DE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1738 49.0483V69.0019",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8145 49.8218V69.155",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M81.8281 66.8307V49.6169L86.5809 49.5652V67.0374L81.8281 66.8307Z",
    fill: "#B1D6DE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6543 49.927V68.9501",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M59.709 50.3374V69.2054",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3672 41.1909V69.984",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9297 50.3374H70.5401V66.3264L66.9297 66.275",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5879 49.6685V66.7272L86.6838 66.9857V49.5134L80.5879 49.6685Z",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9316 49.6169V66.779",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M101.717 66.1587V50.5474L116.492 52.0982V65.2799L101.717 66.1587Z",
    fill: "#B1D6DE"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M101.768 49.3066V66.3137L117.937 65.3832V51.1676L101.768 49.3066Z",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M101.873 50.3923L116.493 51.9431L117.939 51.116",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M116.492 52.0981V65.2799",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M104.92 50.8059V66.0037",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M109.311 51.271V65.8484",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M113.082 51.6846V65.5383",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4062 11.519L34.1959 41.1909",
    stroke: "#8FA1AC"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M18.75 47.394V32.2479L18.9566 32.0412L20.2998 31.5759V47.394H18.75Z",
    fill: "#B1D6DE"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M22.9863 47.1873V30.904L24.7944 30.4387V47.1873H22.9863Z",
    fill: "#B1D6DE"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M61.2662 52.3049L41.377 62.1266V63.6774L61.2662 52.3049Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M116.235 56.1301L104.611 61.9197V62.8502L116.235 56.1301Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M62.3521 55.665L42.4629 65.4867V67.0375L62.3521 55.665Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M116.698 57.8877L105.074 63.6773V64.6078L116.698 57.8877Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4922 45.2889L92.6076 43.2L120.092 48",
    stroke: "#8FA1AC",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M24.8906 11.2L37.3322 33.0113L89.6906 38.4L77.9591 21.8563L24.8906 11.2Z",
    fill: "#8FA1AC"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M129.362 68.3692H122.203L93.9997 71.2L69.3471 69.4769L39.7538 70.2154L31.0559 69.4154L29.5634 69.6615L20.0421 68.4308L17.9834 68.7385L9.49139 68H1",
    stroke: "#8FA1AC",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2602 0.00571893C27.9411 -0.0461521 27.6753 0.265074 27.8348 0.524429L35.6517 15.0483L42.5114 27.7567C42.6177 28.0161 42.8836 28.1717 43.1495 28.1717L94.4112 34.5518C94.7302 34.6037 94.9429 34.2406 94.7834 33.9812L79.0602 9.74704C79.0602 9.74704 78.9006 9.59142 78.7943 9.59142L28.2602 0.00571893Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M41.916 2.62842L56.6156 29.7065",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M55.3262 5.20728L70.0257 31.7696",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M67.9629 7.52832L82.9203 33.8328",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M34.9531 13.2019L86.2726 21.1964",
    stroke: "white",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.2c82cd15429fa5360ff9b11672b9b236.svg";
export { ForwardRef as ReactComponent };